export const socialText = {
  facebook: "https://www.facebook.com/DepBeautyBar/",
  instagram: "https://www.instagram.com/depbeautybar/",
  yelp: "https://www.yelp.com/biz/dep-beauty-bar-beaverton",
};
